




























import { SwExtendedVue } from '@sonicwall/unified-ui-framework/src/shared/sw-extended-vue';
import { Component, Prop } from 'vue-property-decorator';
import UUIFComponent from '@/shared/uuifComponent';
import { SwSelect, SelectOption } from '@libs-uuif/shared/sw-select';
import { InfoState } from '../../../core/core.store';

const cssPrefix = 'casApplicationSelectDialog';
const DEFAULT_TEXTFIELD_WIDTH = '29rem';

@Component({
  components:{
    ...UUIFComponent,
    SwSelect,
  },
})
export default class CasApplicationSelectDialog extends SwExtendedVue {

  cssPrefix = cssPrefix;
  selectWidth: string = DEFAULT_TEXTFIELD_WIDTH;

  @Prop({ default: false })
  showCasApplicationSelectDialog: boolean;

  @Prop()
  data: any;

  get casApplicationOptions() : SelectOption[] {
    const temp : SelectOption[] = [];
    this.casApplicationList &&
    this.casApplicationList.length > 0 &&
    this.casApplicationList.forEach((casApp: any) => {
      temp.push({
        id: casApp.appValue,
        label: casApp.appName,
        value: casApp.appValue,
      });
    });
    return temp;
  }

  casApplicationList: any[] = [];
  selectedCasApplication: string = '';

  mounted() {
    this.getCasApplications();
  }

  getCasApplications() {
    this.casApplicationList = [];
    const request = {
      activationKey: '',
      ssipn: '',
    };
    this.$store.dispatch('CatalogStoreModule/getCasAppilations', request)
      .then((response: any) => {
        this.$store.commit('stopLoading');
        if (response.operationStatus === 'OK') {
          this.casApplicationList = response.content.hasOwnProperty('casbAppList') ? response.content.casbAppList : [];
          if (this.casApplicationList.length > 0) {
            this.selectedCasApplication = this.casApplicationList[0] ? this.casApplicationList[0].appValue : '';
          }
        } else {
          this.$store.commit('stopLoading');
          const message: InfoState = { infoType: 'high', infoMsg: response.msgDesc ? response.msgDesc :  'Operation is unsuccesful' };
          this.$store.commit('displayMessage', message);
        }
      })
      .catch((errorResponse: any) => {
        this.$store.commit('stopLoading');
        const message: InfoState = { infoType: 'high', infoMsg: errorResponse.msgDesc ? errorResponse.msgDesc :  'Operation is unsuccesful' };
        this.$store.commit('displayMessage', message);
      });
  }
  closeDialog() {
    this.$emit('close-dialog');
  }
  onSelectCasApplication() {
    this.$emit('close-dialog', this.selectedCasApplication);
  }
  onChangeCasApp(value: any) {
    this.selectedCasApplication = value;
  }
}
